export default __webpack_public_path__ + "static/media/event.6302ae63.svg";